import { Component, OnInit, OnDestroy, AfterViewInit, HostBinding, ViewChild } from '@angular/core';
import { IxellAPIService, IProductV1, ICompanyV1, IRentingV1, IRentingOrderV1 } from 'src/app/tools/api.service';
import { UntypedFormGroup, Validators, UntypedFormControl } from '@angular/forms';
import { Utils } from 'src/app/tools/utils';
import { Router } from '@angular/router';
import { HeaderService } from 'src/app/tools/header.service';
import { Language } from 'src/app/entities/Language';
import { Constants, Country } from 'src/app/entities/Constants';
import { MatStepper } from '@angular/material/stepper';


@Component({
    selector: 'app-renting',
    templateUrl: './renting.component.html',
    styleUrls: ['./renting.component.scss']
})
export class RentingComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild('stepper') stepper: MatStepper;
    @HostBinding('attr.disabled') disabled: boolean;

    // Sub
    productSub: any;
    ctcSub: any;
    rentingFormSub: any;
    rentingOrderSub: any;
    rentingMailSub: any;

    products: IProductV1[] = [];
    renting: IRentingV1[] = [];

    supportProducts = [
        { "labelP": "Support table par défaut", "picture": "assets/product/SupportBasePro.png", "amountP": 0, "qte": 0 },
    ]

    tauxTva: number = 0;
    isFrench: boolean = false;
    tvaCkeck: boolean = false;

    companyForm = new UntypedFormGroup({
        socialReason: new UntypedFormControl('', [Validators.required]),
        address: new UntypedFormControl('', [Validators.required]),
        postalCode: new UntypedFormControl('', [Validators.required]),
        city: new UntypedFormControl('', [Validators.required]),
        country: new UntypedFormControl('', [Validators.required]),
        siren: new UntypedFormControl(''),
        tva: new UntypedFormControl('')
    });

    rentingForm = new UntypedFormGroup({
        company: this.companyForm,
        leader: new UntypedFormControl('', [Validators.required]),
        bodyshopInterlocutor: new UntypedFormControl('', [Validators.required]),
        companyPhone: new UntypedFormControl(''),
        companyMail: new UntypedFormControl('', [Validators.email, Validators.required]),
        companyDirectLign: new UntypedFormControl('', [Validators.required]),
        customerStatus: new UntypedFormControl('', [Validators.required]),
        technology: new UntypedFormControl('', [Validators.required]),
        ixellAccount: new UntypedFormControl(''),
        companyType: new UntypedFormControl(''),
        companyTypeName: new UntypedFormControl('')

    });

    finalForm = new UntypedFormGroup({
        ctPhone: new UntypedFormControl('', [Validators.required]),
        rentingDuration: new UntypedFormControl('', [Validators.required])
    });

    company: ICompanyV1[] = [];

    status: string = "";
    technology: string = "";
    companyType: string = "";
    rentingDuration: number = 0;

    totalAmount: number;

    order: IRentingOrderV1[] = [];

    invalidForm: boolean = false;

    ct: string = "";
    ctMail: string = "";
    ctPhone: string = "";

    countries: Country[] = [];
    private langue: Language;
    private langueSub: any;

    public selection: string;
    isInputDisabled: boolean = false;
    rentingDurationError: boolean = false;

    // Gestion des supports
    supportBaseQty = 1;
    supportSelected: boolean = false;
    lstProduct: IProductV1;
    lstFraisLiv: number;

    // Cas spécial si italie
    isItaly: boolean = false;

    rentingID: number;

    priceRegex: RegExp = /[.,]00$/;

    constructor(private apiServices: IxellAPIService, private router: Router, private headerService: HeaderService) { }

    ngOnInit() {
        this.selection = "reseau";
        this.countries = Utils.countries();
        this.langueSub = this.headerService.currentLangue.subscribe(langue => {
            this.langue = langue;
        });
        this.headerService.changeTitle("support.supportAssistance");
        this.headerService.changeCanBack(true);
        this.totalAmount = 0;
        this.productSub = this.apiServices.selectRentingProducts().subscribe(data => {
            data.forEach(el => el.qte = 0);
            this.products = data;
            if (this.productSub != null) this.productSub.unsubscribe();
            this.ctcSub = this.apiServices.getCtcInfos().subscribe(data => {
                if (data) {
                    this.ct = data.firstname + " " + data.name;
                    this.ctMail = data.mail;
                    this.ctPhone = data.phone;
                }
                if (this.ctcSub != null) this.ctcSub.unsubscribe();
            }, error => {
                console.log(error);
                if (this.ctcSub != null) this.ctcSub.unsubscribe();
            })
        }, error => {
            console.log(error);
            if (this.productSub != null) this.productSub.unsubscribe();
        });


    }

    ngAfterViewInit() {
        this.stepper._getIndicatorType = () => 'number';
        let reseauName = document.getElementById("reseauName") as HTMLInputElement;
        reseauName.style.visibility = "visible";
    }



    changeCountryFacturation() {
        if (this.companyForm.value.country) {

            var tvaRegEx = Constants.countries.find(c => c.name == this.companyForm.value.country).tvaRegEx;
            if (tvaRegEx != "") {
                this.companyForm.controls['tva'].setValidators([Validators.required, Validators.pattern(Constants.countries.find(c => c.name.toLowerCase() == this.companyForm.value.country.toLowerCase()).tvaRegEx)]);
                this.companyForm.controls['tva'].updateValueAndValidity();
                this.tvaCkeck = true;
            } else {
                this.companyForm.controls['tva'].clearValidators();
                this.companyForm.controls['tva'].updateValueAndValidity();
                //this.companyForm.controls['tva'].markAsTouched();
                if (this.companyForm.value.tva != "") {
                    //this.companyForm.get('tva').patchValue("", { emitEvent: false });
                    this.companyForm.controls["tva"].setValue("");
                }
                this.tvaCkeck = false;
            }

        }

        //let countryFact: string = this.companyForm.value["country"];
        //if (countryFact && countryFact.toLowerCase() == "france") {
        //  this.isFrench = true;
        //  this.tauxTva = 20;
        //}
        //else {
        //  this.isFrench = false;
        //  this.tauxTva = 0;
        //}
        ////this.tva = (this.tauxTva * this.orderAmountFL) / 100;
        ////this.orderAmountTTC = this.orderAmountFL + this.tva;
    }

    checkTvaIntra() {
        //this.changeCountryFacturation()
        let countryFact: string = this.companyForm.value["country"];
        if (countryFact && countryFact.toLowerCase() == "france") {
            this.isFrench = true;
            this.tauxTva = 20;
        }
        else {
            this.isFrench = false;
            this.tauxTva = 0;
        }
    }



    ngOnDestroy() {
        if (this.productSub != null) this.productSub.unsubscribe();
        if (this.ctcSub != null) this.ctcSub.unsubscribe();
        if (this.rentingFormSub != null) this.rentingFormSub.unsubscribe();
        if (this.rentingOrderSub != null) this.rentingOrderSub.unsubscribe();
        if (this.rentingMailSub != null) this.rentingMailSub.unsubscribe();
    }

    companyTypeChange(type: string) {
        if (type == "reseau")
            this.isInputDisabled = false;
        if (type == "enseigne")
            this.isInputDisabled = true;
    }

    setDataCompanyName(value: any, type: string) {
        this.rentingForm.controls['companyTypeName'].setValue(value);
        this.rentingForm.controls['companyType'].setValue(type);
    }

    updateCountry(country: any) {
        this.changeCountryFacturation();
        this.updateFraisLiv(country.value);
    }

    updateFraisLiv(country: string) {
        this.products.forEach(el => {
            if (el.fraisLivRentable == 1) {
                let fraisLiv = 0;
                switch (country.toLowerCase()) {
                    case 'france':
                        fraisLiv = el.fraisLivP;
                        break;
                    case 'germany':
                        fraisLiv = el.fraisLivDEP;
                        break;
                    case 'belgium':
                        fraisLiv = el.fraisLivBEP;
                        break;
                    case 'spain':
                        fraisLiv = el.fraisLivESP;
                        break;
                    case 'italy':
                        fraisLiv = el.fraisLivITP;
                        break;
                    case 'netherlands':
                        fraisLiv = el.fraisLivNLP;
                        break;
                    case 'poland':
                        fraisLiv = el.fraisLivPLP;
                        break;
                    case 'portugal':
                        fraisLiv = el.fraisLivPTP;
                        break;
                    case 'united kingdom':
                        fraisLiv = el.fraisLivENP;
                        break;
                    case 'romania':
                        fraisLiv = el.fraisLivROP;
                        break;
                    case 'turkey':
                        fraisLiv = el.fraisLivTRP;
                        break;
                }
                let price = el.amountP;
                if (this.lstFraisLiv > 0) {
                    price = el.amountP - this.lstFraisLiv;
                }
                let priceWFraisLiv = price + fraisLiv;
                this.lstFraisLiv = fraisLiv;
                let prodIndex = this.products.findIndex(elem => elem.productID == el.productID);
                this.products[prodIndex].amountP = priceWFraisLiv;
            }
        })
        if (country == "Italy") {
            this.isItaly = true;
        } else {
            this.isItaly = false;
        }
    }

    addProduct(labelP: string) {
        let productI = this.products.findIndex(el => el.labelP == labelP);
        if (labelP == "supportBase") {
            // Si un autre support a été ajouté
            if (this.lstProduct) {
                this.totalAmount = this.totalAmount - (this.lstProduct.amountP * this.lstProduct.qte);
            }
            this.products.forEach(element => {
                if (element.typeP == 2 && element != this.products[productI]) {
                    element.qte = 0;
                }
            });
            this.supportBaseQty = 1;
            this.supportSelected = false;
        } else {
            // Cas du support: seul un est selectionnable
            if (this.products[productI].typeP == 2) {
                // Dans le cas où on change entre les deux supports payants
                if (this.lstProduct != null) {
                    if (this.lstProduct.labelP != this.products[productI].labelP) {
                        this.totalAmount = this.totalAmount - (this.lstProduct.amountP * this.lstProduct.qte);
                    }
                }
                this.lstProduct = this.products[productI];
                this.supportSelected = true;
                this.supportBaseQty = 0;
                this.products.forEach(element => {
                    if (element.typeP == 2 && element != this.products[productI]) {
                        element.qte = 0;
                    }
                });
            }

            if (this.products[productI].qteStock === 0 || this.products[productI].qte < this.products[productI].qteStock) {
                // Modification de la quantité
                let blbl = this.products[productI].qte + 1;
                this.products[productI].qte = blbl;
                // Modification du prix
                let blbl2 = this.totalAmount + this.products[productI].amountP;
                this.totalAmount = Math.round(blbl2 * 100) / 100;
            }
        }

    }

    removeProduct(labelP: string) {
        let productI = this.products.findIndex(el => el.labelP == labelP);
        if (this.supportBaseQty == 0 && this.products[productI].typeP == 2 && this.products[productI].qte == 1) {
            this.products[productI].qte = this.products[productI].qte - 1;
            this.totalAmount = this.totalAmount - this.products[productI].amountP;
            this.supportBaseQty = 1;
            this.supportSelected = false;
        } else {
            if (this.products[productI].qte > 0) {
                // Modification de la quantité
                let blbl = this.products[productI].qte - 1;
                this.products[productI].qte = blbl;
                // Modification du prix
                let blbl2 = this.totalAmount - this.products[productI].amountP;
                this.totalAmount = Math.round(blbl2 * 100) / 100;
            }
        }
    }

    insertRentingOrder(rentingID: number) {
        this.rentingOrderSub = this.apiServices.insertRentingOrder(this.order, rentingID).subscribe(data2 => {
        }, error => {
            console.log(error)
            if (this.rentingOrderSub != null) this.rentingOrderSub.unsubscribe();
        })
    }

    sendRentingMail(rentingID: number) {
        this.rentingMailSub = this.apiServices.sendRentingMail(rentingID, 0).subscribe(response => {
            if (this.rentingMailSub != null) this.rentingMailSub.unsubscribe();
        }, error => {
            console.log(error);
            if (this.rentingMailSub != null) this.rentingMailSub.unsubscribe();
        })
    }

    sendData() {
        if (this.ctPhone) {
            this.finalForm.controls['ctPhone'].setValue(this.ctPhone);
        }
        if (this.isItaly) {
            this.finalForm.controls['rentingDuration'].markAsTouched();
            this.finalForm.controls['rentingDuration'].setValue(5);
        }

        if (this.companyForm.status == "VALID" && this.rentingForm.status == "VALID" && this.finalForm.status == "VALID") {
            let rentingObj = new IRentingV1();
            rentingObj = this.rentingForm.value;
            rentingObj.companyid = this.companyForm.value;
            rentingObj.rentingDuration = parseInt(this.finalForm.value.rentingDuration);
            rentingObj.ctPhone = this.finalForm.value.ctPhone;


            // Cas paiement comptant Italie
            if (this.isItaly) {
                rentingObj.status = 4;
                rentingObj.rentingDuration = 5;
                rentingObj.cashPayement = 1;
            } else {
                rentingObj.status = 0;
            }
            let tabOrder: any[] = []
            this.products.forEach(el => {
                if (el.qte > 0) {
                    let productid = el.productID;
                    let productqte = el.qte;
                    let productamount = el.amountP;
                    tabOrder.push({ productid, productqte, productamount });
                }
            });
            this.order = tabOrder;
            var isUpdateCtphone = false;
            if (!Utils.IsNullOrWhiteSpace(rentingObj.ctPhone) && this.ctPhone != rentingObj.ctPhone) {
                isUpdateCtphone = true;
            }

            rentingObj.order = this.order;
            this.rentingFormSub = this.apiServices.insertRentingFormGlobal(rentingObj, isUpdateCtphone, 0).subscribe(data => {
                if (data > 0) {
                    document.getElementById("finalModal").style.display = "block";
                }
            }, error => {
                console.log(error)
                if (this.rentingFormSub != null) this.rentingFormSub.unsubscribe();
            });

            //this.rentingFormSub = this.apiServices.insertRentingForm(rentingObj, isUpdateCtphone).subscribe(data => {
            //    if (data > 0) {
            //        this.rentingID = data;
            //        if (this.order.length > 0) {
            //            this.insertRentingOrder(this.rentingID);
            //            setTimeout(() => { this.sendRentingMail(this.rentingID) }, 700);
            //        }
            //        else {
            //            this.sendRentingMail(this.rentingID);
            //        }
            //        document.getElementById("finalModal").style.display = "block";
            //    }
            //}, error => {
            //    console.log(error)
            //    if (this.rentingFormSub != null) this.rentingFormSub.unsubscribe();
            //});

            this.invalidForm = false;
        } else {
            this.invalidForm = true;
            if (Utils.IsNullOrWhiteSpace(this.rentingForm.value.companyType))
                document.getElementById("companyType").style.color = "red";

            if (Utils.IsNullOrWhiteSpace(this.rentingForm.value.technology))
                document.getElementById("technology").style.color = "red";

            if (Utils.IsNullOrWhiteSpace(this.rentingForm.value.customerStatus))
                document.getElementById("tarif").style.color = "red";

            if (Utils.IsNullOrWhiteSpace(this.rentingForm.value.rentingDuration) && this.companyForm.value.country != "Italy") {
                document.getElementById("3years").style.color = "#f44336";
                document.getElementById("5years").style.color = "#f44336";
            }
        }
    }


    checkboxError() {
        if (Utils.IsNullOrWhiteSpace(this.rentingForm.value.companyType))
            document.getElementById("companyType").style.color = "#f44336";
        if (Utils.IsNullOrWhiteSpace(this.rentingForm.value.technology))
            document.getElementById("technology").style.color = "#f44336";
        if (Utils.IsNullOrWhiteSpace(this.rentingForm.value.customerStatus))
            document.getElementById("tarif").style.color = "#f44336";
    }


    removeCheckboxError(checkbox: string) {
        switch (checkbox) {
            case "companyType":
                if (document.getElementById("companyType").style.color = "#f44336")
                    document.getElementById("companyType").style.color = "black"
                break;
            case "technology":
                if (document.getElementById("technology").style.color = "#f44336")
                    document.getElementById("technology").style.color = "black"
                break;
            case "tarif":
                if (document.getElementById("tarif").style.color = "#f44336")
                    document.getElementById("tarif").style.color = "black"
                break;
        }
    }

    removerDurationError() {
        if (document.getElementById("3years").style.color = "#f44336")
            document.getElementById("3years").style.color = "black";

        if (document.getElementById("5years").style.color = "#f44336")
            document.getElementById("5years").style.color = "black";
    }

    closeModal() {
        this.router.navigate(['/home']);
    }

}
